module.exports = __webpack_public_path__ + "img/72.b4dc414.png";